import { validateItau } from './bank-validator/itau-validator';
import { validateBradesco } from './bank-validator/bradesco-validator';
import { validateBb } from './bank-validator/bb-validator';
import { validateSantander } from './bank-validator/santander-validator';
import { validateNubank } from './bank-validator/nubank-validator';
import { validateBanrisul } from './bank-validator/banrisul-validator';

export function analyseBankInfo(bankCode, branchNumber, number, checkDigit) {
  switch (bankCode) {
    case '1': // BB
      return validateBb(number, checkDigit);
    case '237': // Bradesco
      return validateBradesco(number, checkDigit);
    case '33': // Santander
    return validateSantander(branchNumber, number, checkDigit);
    case '341': // Itaú
      return validateItau(branchNumber, number, checkDigit);
    case '260': // Nubank
      return validateNubank(number, checkDigit);
    case '41': // Banrisul
      return validateBanrisul(number, checkDigit);
    case '336': // C6
    case '77': // Inter
    case '104': // Caixa
    default:
      return true;
  }
}
